import React, {useEffect, useState} from 'react';
import BasketProductPriceBlock from '../basketProductPriceBlock';
import {decode} from 'html-entities';
import InfoIcon from '../images/info-new.svg';
import CheckIcon from '../images/check.svg';

function BasketProduct(props) {

  const [canRemove, setCanRemove] = useState(true);
  const product = props.product;
  const isWarranty = Boolean(product.WARRANTY_DATA.WARRANTY_TYPE);
  const isService = Number(product.WARRANTY_DATA.TYPE) === 3;
  const hasProductLink = !isWarranty && !isService;

  // установка признака вохможности обновления
  useEffect(() => {
    setCanRemove(props.canRemove);
  }, [props.canRemove]);

  function showPreview(event) {
    event.preventDefault();
    event.stopPropagation();
    // формируем и показываем окно с описанием
    import(/* webpackPreload: true */ '../../../popup').then(module => {
      let popup = new module.Popup('additional-basket-products', false, false,
          true);
      // Устанавливаем тело окна
      popup.body =
          `<div class="additional-product-popup-title">${product.NAME}</div>` +
          `<div class="additional-product-popup-body">${product.PREVIEW_TEXT}</div>`;
      popup.open();
    });
  }

  function renderFavoriteButton() {
    if (product.WARRANTY_DATA.WARRANTY_TYPE || !Number(product.PRODUCT_ID)) {
      return null;
    }

    return (
        <a href="#" className="favorite-link basket-favorite-link"
           onClick={event => event.preventDefault()}>
          <i className="icon-basket-favorite"
             data-container="favorite"
             data-id={product.PRODUCT_ID}
             data-link="/personal/wishlist/"
             data-use="add"/>
        </a>
    );
  }

  return (
      <div className="order-detail-item">
        <div className="order-detail-img">
          {
            hasProductLink ?
                <a href={product.URL} className="order-detail-img-link">
                  <img src={product.IMAGE_150_SRC} alt={decode(product.NAME)}
                       loading={'lazy'}/>
                </a> :
                <div className="order-detail-img-link">
                  <img src={product.IMAGE_150_SRC}
                       className={isWarranty ? 'order-detail-img-link-warranty' : ''}
                       onClick={isWarranty ? showPreview : undefined}
                       alt={decode(product.NAME)}
                       loading={'lazy'}/>
                </div>
          }
        </div>
        <div className="order-detail-info"
             data-product-id={product.PRODUCT_ID}
             data-price={product.DISPLAY_PRICE.PRICE}
             data-cart-product={btoa(JSON.stringify(
                 {
                   productId: product.ID,
                   price: product.DISPLAY_PRICE.PRICE,
                   quantity: product.QUANTITY,
                   currency: product.BASKET_PRICE.CURRENCY,
                 },
             ))}
             data-container="offerDetailInfo">
          {
            product.CAN_PICKUP_TODAY ?
              <div className="mb-[6px] text-[#2FB600] font-medium flex gap-[5px] text-[11px] items-start min-1024:text-[12px] min-1024:items-center ">
                <img src={CheckIcon}
                     width={`12px`}
                     height={`9px`}
                     className="pt-[2px] min-1024:pt-0"
                />
                {props.getMessage('PICKUP_TODAY')}
              </div> :
              <></>
          }
          <span className="order-detail-linkname-underline">
          {
            hasProductLink ?
                <a href={product.URL} className="order-detail-linkname">{decode(
                    product.NAME)}</a> :
              <span className={`order-detail-linkname${isWarranty ? ' warranty-item' : ''}`}
                    onClick={isWarranty ? showPreview : undefined}>
                <span>{decode(product.NAME)}</span>
                {
                  isWarranty ?
                    <img src={InfoIcon}
                         width={`14px`}
                         height={`14px`}
                         alt={`info`}
                         title={`info`}
                    /> :
                    <></>
                }
              </span>
          }
          </span>
          {
            product.ARTICLE ?
              <div className="code break-all"><span>{product.ARTICLE}</span></div> :
              <></>
          }
          <div className="order-detail-row">
            <div className="col-quantity">
              {
                !product.GIFT ?
                    <div className="basket_quantity_control">
                      <div className="quantity_control"
                           onClick={e => {
                             e.preventDefault();
                             e.stopPropagation();
                             props.updateBasketQuantity(product.ID,
                                 product.QUANTITY - 1, true, product.PRODUCT_ID, 'remove');
                           }}>
                        <a href="#" className="minus"/>
                      </div>
                      <span className="item_quantity">{product.QUANTITY}</span>
                      <div className="quantity_control"
                           onClick={e => {
                             e.preventDefault();
                             e.stopPropagation();
                             props.updateBasketQuantity(product.ID,
                                 product.QUANTITY + 1, true, product.PRODUCT_ID, 'add');
                           }}>
                        <a href="#" className="plus"/>
                      </div>
                    </div> :
                    <></>
              }
            </div>
            {
              props.clietWidth < 1024 ?
                  <div className={'price-action'}>
                    <BasketProductPriceBlock product={product}
                                             getMessage={props.getMessage}/>
                  </div> :
                  <></>
            }
          </div>
        </div>
        {
          props.clietWidth >= 1024 ?
              <div className={'price-action'}>
                <BasketProductPriceBlock product={product}
                                         getMessage={props.getMessage}/>
                <div className='flex flex-col gap-[13px]'>
                  {renderFavoriteButton()}
                  {
                    canRemove && (<i className="ic-basket-remove remove"
                                     onClick={e => {
                                       e.preventDefault();
                                       e.stopPropagation();
                                       props.removeFromBasket(
                                         {
                                           cartId: product.ID,
                                           productId: product.PRODUCT_ID,
                                           quantity: product.QUANTITY - 1
                                         });
                                     }}/>)

                  }
                </div>
              </div> :
              <div className='flex flex-col gap-[13px]'>
                {renderFavoriteButton()}
                {
                    canRemove &&
                    (<i className="ic-basket-remove remove"
                        onClick={e => {
                          e.preventDefault();
                          e.stopPropagation();
                          props.removeFromBasket(
                              {
                                cartId: product.ID,
                                productId: product.PRODUCT_ID,
                                quantity: product.QUANTITY - 1
                              });
                        }}/>)
                }
              </div>
        }
      </div>
  );
}

export default BasketProduct;